/* eslint-disable react/no-deprecated */
import { Component } from 'react';
import PropTypes from 'prop-types';
import TakeawayDisplay from 'legacy/javascripts/components/takeaway_display.es6.jsx';
import { DateTime } from 'common/utils/date';

const get = (obj, path, defValue) => {
  if (!path) return undefined;
  const pathArray = Array.isArray(path) ? path : path.match(/([^[.\]])+/g);
  const result = pathArray.reduce(
    (prevObj, key) => prevObj && prevObj[key],
    obj,
  );
  return result === undefined ? defValue : result;
};

class TeamDataPerMemberClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      key_name: this.props.data.initial_sort || 'name',
      order: this.props.data.initial_sort ? 'desc' : 'asc',
      tab: this.props.data.tabs[0],
      mousePosition: {
        clientX: 0,
        clientY: 0,
      },
    };
    this.sortIterator = this.sortIterator.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.categoryColumn = this.categoryColumn.bind(this);
    this.setMousePosition = this.setMousePosition.bind(this);
  }

  handleTabClick(e) {
    this.setState({ tab: e.target.dataset.tabName });
  }

  sortArrow() {
    return (
      <svg
        className="arrow"
        focusable="false"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z" />
      </svg>
    );
  }

  multiColumnHeader(column, index) {
    return (
      <div className="sub-widgetCell">
        {column.sub_columns.map(function (column, subIndex) {
          return (
            <div className="cellContent" key={`cell-${subIndex}`}>
              {column.header}
            </div>
          );
        }, this)}
      </div>
    );
  }

  headerCell(column, index) {
    return (
      <th
        className="widgetCell"
        key={`header-${index}`}
        onClick={this.handleSort.bind(this, column)}
        data-column-key={column.key}
        data-column-display={column.display}
        data-visible={column.tab === undefined || this.state.tab === column.tab}
        data-sort-order={
          this.state.key_name === column.key ? this.state.order : ''
        }
      >
        <div className="cellContent">
          {column.header}
          {this.sortArrow()}
        </div>
        {column.sub_columns && this.multiColumnHeader(column)}
      </th>
    );
  }

  profileColumn(member, column, index) {
    const { start_date_display, end_date_display } = this.props.filters;
    const dateFilters = `start_date=${start_date_display}&end_date=${end_date_display}`;
    const agentTrendsUrl = `/trends/team_member?employee_id=${member.id}&${dateFilters}`;

    return (
      <a
        className="profile-link"
        href={agentTrendsUrl}
      >
        <span className="profile-img">
          <img src={member.image} />
        </span>
        <div className="profile-name" data-notranslate>
          {member.name}
        </div>
      </a>
    );
  }

  trendColumn(member, column, index) {
    const [value, trendValue] = member[column.key];
    return (
      <div className="sub-widgetCell">
        {this.formatValue(value, index)}
        {this.formatValue(trendValue, index, 1)}
      </div>
    );
  }

  setMousePosition(event) {
    event.persist();
    const { clientX, clientY } = event;
    this.setState({ mousePosition: { clientX, clientY } });
  }

  categoryColumn(member, column, index) {
    const { needs_work } = member[column.key];
    const { clientX, clientY } = this.state.mousePosition;
    return (
      <div className="takeaway-category-cell">
        {needs_work.length > 0 ? (
          <span className="takeaway-type-indicator needs-work">
            <span
              className="takeaway-number"
              onMouseOver={this.setMousePosition}
            >
              {needs_work.length}
            </span>

            <div
              className="takeaways-popup"
              style={{ left: clientX - 300, top: clientY }}
            >
              <div className="takeaways-display">
                <div className="takeaways-display-wrap">
                  {needs_work.map(t => (
                    <TakeawayDisplay key={t.id} {...t} />
                  ))}
                </div>
              </div>
            </div>
          </span>
        ) : (
          <span className="takeaway-type-indicator" />
        )}
      </div>
    );
  }

  scoreColumn(member, column, index) {
    const scoreObj = get(member, column.key);
    if (!scoreObj) return '–';

    const { score, count } = scoreObj;
    return `${score}% (${count})`;
  }

  dateColumn(member, column, index) {
    if (member[column.key] === null) return '–';
    return DateTime.fromISO(member[column.key]).toLocal().toRelative();
  }

  contentCell(member, column, index) {
    let display;

    const val = get(member, column.key, null);

    switch (column.display) {
      case 'profile_column':
        display = this.profileColumn(member, column, index);
        break;
      case 'trend_column':
        display = this.trendColumn(member, column, index);
        break;
      case 'category_column':
        display = this.categoryColumn(member, column, index);
        break;
      case 'date_column':
        display = this.dateColumn(member, column, index);
        break;
      case 'score':
        display = this.scoreColumn(member, column, index);
        break;
      default:
        display = typeof val === 'number' ? this.formatValue(val, index) : val;
    }

    return (
      <td
        className="widgetCell"
        key={`cell-${member.id}-${column.key}-${index}`}
        data-visible={column.tab === undefined || this.state.tab === column.tab}
        data-column-display={column.display}
      >
        {display === null ? '–' : display}
      </td>
    );
  }

  netDifference(value) {
    return value > 0 ? 'pos' : 'neg';
  }

  notTrend(subIndex) {
    return !subIndex || subIndex === 0;
  }

  formatValue(value, index, subIndex) {
    if (value === null) return <div>–</div>;

    const displayOptions = this.props.data.columns[index];
    let display = value.toFixed(displayOptions.decimal_places);
    value = display;

    if (displayOptions.display === 'percent_column') display += '%';

    if (this.notTrend(subIndex)) return <div>{display}</div>;
    return (
      <div className={`net ${this.netDifference(value)}`}>
        <span>{display.replace('-', '')}</span>
      </div>
    );
  }

  getTabs() {
    return (this.props.hideTabs || false) ? [this.state.tab] : this.props.data.tabs;
  }

  getDisplayableColumns() {
    const tabs = this.getTabs();
    return this.props.data.columns.filter(
      ({ tab }) => tab === undefined || tabs.indexOf(tab) >= 0,
    );
  }

  sortIterator(member) {
    const displayColumn = this.props.data.columns.find(
      item => item.key === this.state.key_name,
    ).display;

    let value = get(member, this.state.key_name, null);
    if (displayColumn === 'trend_column') {
      [value] = value;
    } else if (displayColumn === 'category_column') {
      value = value.needs_work.length;
    } else if (displayColumn === 'score') {
      value = get(value, 'score', null);
    } else if (displayColumn === 'date_column') {
      value = Date.parse(value);
    }

    const last_in_list = this.state.order === 'asc' ? Infinity : -Infinity;
    return value === null ? last_in_list : value;
  }

  handleSort(column) {
    let order = this.state.order === 'asc' ? 'desc' : 'asc';
    if (this.state.key_name !== column.key)
      order = column.default_sort_order || 'desc';

    this.setState({ key_name: column.key, order: order });
  }

  render() {
    const { datasetKey = 'overall', exportable = true, hideTabs = false } = this.props;
    const { columns, datasets } = this.props.data;
    const dataset = datasets[datasetKey]
      .concat()
      .sort((a, b) =>
        a[this.sortIterator(a)] > b[this.sortIterator(b)]
          ? this.state.order === 'asc'
            ? 1
            : -1
          : b[this.sortIterator(b)] > a[this.sortIterator(a)]
          ? this.state.order === 'asc'
            ? -1
            : 1
          : 0,
      );

    const tabs = this.getTabs();
    const showCoaching = tabs.indexOf('1:1s') >= 0;
    const displayableColumns = this.getDisplayableColumns();

    return (
      <div className="teamTable">
        <div className="tabs">
          {hideTabs ||
            tabs.map(tab => (
              <button
                className="tab"
                key={tab}
                data-tab-name={tab}
                onClick={this.handleTabClick}
                data-selected={this.state.tab === tab}
              >
                {tab}
              </button>
            ))}
          {exportable && (
            <a
              href={`/trends/team/export.csv?start_date=${this.props.filters.start_date_display}&end_date=${this.props.filters.end_date_display}&team_leader=${this.props.filters.team_leader}`}
              target="_blank"
              rel="noopener noreferrer"
              title="export (new tab)"
              rel="noreferrer"
            >
              <button className="action-button">Export</button>
            </a>
          )}
        </div>
        <div className="scrollable-table">
          <table className="">
            <thead
              className="widgetRow widgetHeader"
              style={{ paddingRight: tabs.length ? '20px' : '0' }}
            >
              <tr>
                {displayableColumns.map((column, index) =>
                  this.headerCell(column, index),
                )}
                {showCoaching && <th></th>}
              </tr>
            </thead>

            <tbody>
              {dataset.length ? (
                dataset.map((member, rowIndex) => {
                  return (
                    <tr
                      className="widgetRow data-row"
                      key={`row-${datasetKey}-${member.id}`}
                      style={{ paddingRight: showCoaching ? '20px' : '0' }}
                    >
                      {displayableColumns.map((column, index) =>
                        this.contentCell(member, column, index),
                      )}

                      {showCoaching && (
                        <td className="row-actions">
                          <button
                            className="row-actions-btn"
                            htmlFor={`employee-action-${member.id}`}
                          >
                            <i className="fa fa-ellipsis-v" />
                          </button>
                          <div className="row-actions-menu">
                            <a
                              className="row-actions-link"
                              href={`/one_on_ones?employee_id=${member.id}`}
                            >
                              <i className="fa fa-plus" />
                              <span>New Session</span>
                            </a>
                          </div>
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <div className="widgetRow empty" />
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default TeamDataPerMemberClass;
/* eslint-enable react/no-deprecated */
